import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import QuotaAlert from './quota-alert';
import styles from './styles.scss';

const TemplateQuotaAlert: types.TriggerComponent = ({ onSkip }) => {
  return (
    <QuotaAlert
      triggerType={onSkip}
      type="template"
    >
      <div className={styles.quotaText}>
        <FormattedMessage
          id=""
          description="text for a modal on prep and send that says you are over your template limit"
          defaultMessage="Your current plan does not have any more templates / template links available. You can still create one, but won't be able to use it until you have upgraded to a higher plan." />
        <br /><br />
        <FormattedMessage
          id=""
          description="text for a modal on prep and send that says the template will be locked or in test mode if you're an API user"
          defaultMessage="If you are an API user, locked templates can still be used in test mode." />
      </div>
    </QuotaAlert>
  );
};

TemplateQuotaAlert.needsTrigger = (state, _formik) => {
  const isTemplateRequest = selectors.isTemplateRequest(state);
  const isAtTemplateLimit = selectors.isAtTemplateLimit(state);

  // since isTemplateRequest covers UI Template & Template Link
  // we don't need embedded template specific condition here
  return isTemplateRequest && isAtTemplateLimit;
};

export default TemplateQuotaAlert;
